import React from 'react';
import {
  Routes,
  Route
} from 'react-router-dom';

import IndexPage from './pages/Index.js';
import LoginPage from './pages/Login.js';
import RegisterPage from './pages/Register.js';
import DashboardPage from './pages/Dashboard.js';
import SettingsPage from './pages/Settings.js';
import TermsAndConditionsPage from './pages/TermsAndConditions.js';
import PlanSelectionPage from './pages/PlanSelection.js';
import CheckoutPage from './pages/Checkout.js';
import StripePricingPage from './pages/StripePricing.js';
import AcceptInvitePage from './pages/AcceptInvite.js';
import SharePage from './pages/Share.js';

function App() {
  return (
    <Routes>
      <Route path="/" element={<IndexPage />} />
         
      <Route path="/login" element={<LoginPage />} />
         
      <Route path="/register" element={<RegisterPage />} />
         
      <Route path="/dashboard" element={<DashboardPage />} />
         
      <Route path="/settings" element={<SettingsPage />} />
         
      <Route path="/terms-and-conditions" element={<TermsAndConditionsPage />} />
         
      <Route path="/plan-selection" element={<PlanSelectionPage />} />
         
      <Route path="/stripe-pricing" element={<StripePricingPage />} />
         
      <Route path="/checkout" element={<CheckoutPage />} />
      <Route path="/accept-invite" element={<AcceptInvitePage />} />
      <Route path="/share" element={<SharePage />} />
    </Routes>
  );
}

export default App;
